<template>
    <!-- Modals -->
    <div class="row justify-content-center align-items-center">
        <div class="col-md-4">
            <base-button id= "calmodal" block type="warning" class=" mb-3" @click="modals.modal2 = true" hidden>
                Select picture
            </base-button>

            <modal :show.sync="modals.modal2"
                    body-classes="p-0"
                    modal-classes="modal-dialog-centered modal-sm">
                <h6 slot="header" class="modal-title" id="modal-title-notification"></h6>

                <div id="modal-title-content" class="py-3 text-center">
                    <i class="ni ni-bell-55 ni-3x"></i>
                    <h4 id="modal-title-notificationH" class="heading mt-4">Result</h4>
                   
                </div>
            </modal>
        </div>
    </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal
  },
  data() {
    return {
      modals: {
        modal2: false
      }
    };
  },
  methods: {


  }
};
</script>
<style>
</style>
